import { Image, Modal, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function UnwrapModal({ isOpen, setIsOpen }) {
  const { t } = useTranslation();

  function onRequestClose() {
    setIsOpen(false);
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={t('unwrapEffect')}
      primaryButtonProps={{
        children: t('okay'),
        onClick: onRequestClose
      }}
    >
      <S.ModalBody>
        <S.Col>
          <Typography variant="body1Bold">{t('unwrapModalTitle')}</Typography>
          <Typography variant="body2">{t('unwrapModalP1')}</Typography>
          <Typography variant="body2">{t('unwrapModalP2')}</Typography>
        </S.Col>
        <S.Col>
          <Image name="scratch" width={340} />
        </S.Col>
      </S.ModalBody>
    </Modal>
  );
}

export { UnwrapModal };
